export const list = {
  table: {
    id: '順番',
    name: '洗剤名',
    price: '仕入れ金額(円)',
    netWeightG: '内容量(重量:g)',
    netWeightMl: '内容量(容量:ml)',
    specificGravity: '比重',
    costPerMl: '1ml当たり原価(円)',
    remainingQuantity: '在庫数量(ケース)',
    thresholdQuantity: 'アラート設定数量(ケース)',
    g: 'g',
    ml: 'ml',
    bin: 'ケース',
    importGoods: '仕入れ',
  },
  buttonAction: {
    importAdd: 'インポート（追加）',
    importOverwrite: 'インポート（上書き）',
    export: 'エクスポート',
    update: 'アップデート',
  },
  pageHeader: {
    title: '洗剤リスト　TOP',
    titleDetergentsList: '個人データ登録/編集',
    new: '新規',
  },
}
